import { render, staticRenderFns } from "./goodsInventoryQuotationDetail.vue?vue&type=template&id=fac99ec6&scoped=true"
import script from "./goodsInventoryQuotationDetail.vue?vue&type=script&lang=js"
export * from "./goodsInventoryQuotationDetail.vue?vue&type=script&lang=js"
import style0 from "./goodsInventoryQuotationDetail.vue?vue&type=style&index=0&id=fac99ec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac99ec6",
  null
  
)

export default component.exports